import {Card, Col, Row} from 'react-bootstrap';
import PropertyPicker from './components/PropertyPicker';
import {connect} from 'react-redux';
import BaseFeature from './BaseFeature';
import {PRESENCE_DETECTION, PRESENCE_DETECTION8} from '../../../../../../utils/constantFeatures';
import PropertyDropdown from './components/PropertyDropdown';
import {getMinutes} from '../../../../../../utils/constantValues';
import DraggableAreaChart from './charts/DraggableAreaChart';
import {getErrorIssues} from '../../../../../../utils/validationSummary';
import Checkbox from 'components/shared/StandaloneCheckbox';

class PresenceDetection extends BaseFeature {

    presenceDetectSensorTypes = [
        {
            value: 1,
            name: "LSI sensor",
        },
        {
            value: 3,
            name: "DALI sensor"
        }
    ]

    constructor(props) {
        super(props);

        this.state = {
            isCheckedPDColour: !this.isOn(this.props.extraProperties[PRESENCE_DETECTION8.presenceDetectionColor]),
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeCheckboxes = this.handleChangeCheckboxes.bind(this);
    }

    handleChange(propertyName, value) {
        // in case the propery is from another feature
        if (this.getCorrectPropertyName(propertyName) === PRESENCE_DETECTION8.presenceDetectionColor) {
            let property = this.props.extraProperties[propertyName];
            property.value = value;
            this.props.handleChangeExtraProperties(property);
        } else {
            const v = value;
            this.props.handleChange(propertyName, v);
        }
    }

    isOn(property) {
        return property != null && property.value !== 'Off' && property.value !== property.valueMeta.off;
    }

    handleChangeCheckboxes(e) {
        const checked = e.target.checked;
        switch (e.target.name) {
            case "pdcolour":
                let pdColourTemperature = this.props.extraProperties[PRESENCE_DETECTION8.presenceDetectionColor];
                pdColourTemperature.value = checked ? "Off" : this.props.extraProperties[PRESENCE_DETECTION8.presenceDetectionColor].valueMeta['default'];
                this.props.handleChangeExtraProperties(pdColourTemperature);
                this.setState({isCheckedPDColour: checked});
                break;
            default:
                break;
        }
    }

    getDataChart(properties) {
        let dataChart = [{}, {}, {}, {}, {}];
        dataChart[0] = {
            x: 100,
            y: 0,
            timeLabel: "enter-0",
            section: 0
        }
        const startFadeTimeIndex = properties[PRESENCE_DETECTION.startFadeTime].valueMeta.availableValues.indexOf(properties[PRESENCE_DETECTION.startFadeTime].value);
        dataChart[1] = {
            x: dataChart[0].x + (startFadeTimeIndex > 0 ? (startFadeTimeIndex * 12) : 0),
            y: +properties[PRESENCE_DETECTION.level].value,
            timeLabel: "startFadeTime-1",
            section: 0
        }

        dataChart[2] = {
            x: dataChart[1].x + 180,
            y: +properties[PRESENCE_DETECTION.level].value,
            timeLabel: "exit-0",
            section: 1
        }
        const holdTimeIndex = properties[PRESENCE_DETECTION.holdTime].valueMeta.availableValues.indexOf(properties[PRESENCE_DETECTION.holdTime].value);
        dataChart[3] = {
            x: dataChart[2].x + (holdTimeIndex > 0 ? (holdTimeIndex * 11) : 0),
            y: +properties[PRESENCE_DETECTION.level].value,
            timeLabel: "holdTime-2",
            section: 2
        }
        const endFadeTimeIndex = properties[PRESENCE_DETECTION.endFadeTime].valueMeta.availableValues.indexOf(properties[PRESENCE_DETECTION.endFadeTime].value);
        dataChart[4] = {
            x: dataChart[3].x + (endFadeTimeIndex > 0 ? (endFadeTimeIndex * 12) : 0),
            y: 0,
            timeLabel: "endFadeTime-3",
            section: 3
        }
        return dataChart;
    }

    getDataChartPD(properties) {
        let dataChartPD = [{}, {}, {}, {}];
        let cont = 100;
        dataChartPD[0].x = cont + 0;
        dataChartPD[0].y = 0;
        dataChartPD[1].x = cont + 0;
        dataChartPD[1].y = 50;
        const startFadeTimeIndex = properties[PRESENCE_DETECTION.startFadeTime].valueMeta.availableValues.indexOf(properties[PRESENCE_DETECTION.startFadeTime].value);
        cont += (startFadeTimeIndex > 0 ? (startFadeTimeIndex * 12) : 0);
        cont += 180;
        dataChartPD[2].x = cont + 0;
        dataChartPD[2].y = 50;
        dataChartPD[3].x = cont + 0;
        dataChartPD[3].y = 50;
        return dataChartPD;
    }

    getXLabels(dataChart) {
        const labels = [];
        const smallLabels = [];
        const ticks = [];
        dataChart.forEach((el, index) => {
            switch (el.timeLabel) {
                case 'enter-0':
                    ticks.push(el.x);
                    labels.push({label: 'Enter', x: el.x});
                    break;
                case 'startFadeTime-1':
                    ticks.push(el.x);
                    smallLabels.push({label: '1', x: (el.x + dataChart[index - 1].x) / 2});
                    break;
                case 'exit-0':
                    ticks.push(el.x);
                    labels.push({label: 'Exit', x: el.x});
                    break;
                case 'holdTime-2':
                    ticks.push(el.x);
                    smallLabels.push({label: '2', x: (el.x + dataChart[index - 1].x) / 2});
                    break;
                case 'endFadeTime-3':
                    ticks.push(el.x);
                    smallLabels.push({label: '3', x: (el.x + dataChart[index - 1].x) / 2});
                    break;
                default:
                    break;
            }
        });
        return {labels: labels, smallLabels: smallLabels, ticks: ticks};
    }

    getYLabels() {
        const labels = {};
        //insert max label if max value is not present
        const max = this.props.properties[PRESENCE_DETECTION.level].value;
        if (!labels[max]) {
            labels[max] = {label: max, y: max};
        }
        //insert min label if min value is not present
        const min = 0;
        if (!labels[min]) {
            labels[min] = {label: '', y: min};
        }
        return Object.keys(labels)
            .map((key) => labels[key]);
    }

    render() {
        const level = this.props.properties[PRESENCE_DETECTION.level];
        const startFadeTime = this.props.properties[PRESENCE_DETECTION.startFadeTime];
        const holdTime = this.props.properties[PRESENCE_DETECTION.holdTime];
        const endFadeTime = this.props.properties[PRESENCE_DETECTION.endFadeTime];
        const dataChart = this.getDataChart(this.props.properties);
        const displayColors = this.props.driverFeatures.some(item => item.name === 'pd8');

        const valuesSet = this.props.opmodesSelected?.valuesSet || '';
        const pdEnableMatch = valuesSet.match(/PD-0:Control-PDEnable=(\d+)/);
        const pdEnableValue = pdEnableMatch ? parseInt(pdEnableMatch[1]) : null;
        const presenceDetectionSensorType = {
            value: pdEnableValue,
            info: {name: 'presenceDetectionSensorType', displayName: 'Sensor Type'},
        };
        const disablePDLevel = presenceDetectionSensorType.value === this.presenceDetectSensorTypes.find(pd => pd.name === "DALI sensor").value;
        const disableStartFadeTime = presenceDetectionSensorType.value === this.presenceDetectSensorTypes.find(pd => pd.name === "DALI sensor").value;

        return (
            <Col>
                <Row>
                    <Col sm={4} md={4} lg={4} >
                        <Card className={this.getClassName([level])} style={{width:'100%'}}>
                            <div className="card-header-feature">
                                {'Output Levels'}
                            </div>
                            <Card.Body className="card-body-feature" style={{paddingTop: '0.75rem'}}>
                                <PropertyPicker
                                    disabled={disablePDLevel}
                                    property={level}
                                    inputPadding={'padding-none'}
                                    title={level.info.displayName}
                                    measureUnit={'%'}
                                    min={level.valueMeta.min}
                                    max={level.valueMeta.max}
                                    step={1}
                                    handleChange={this.handleChange}/>
                                {displayColors ?
                                    <PropertyPicker
                                        disabled={this.state.isCheckedPDColour}
                                        property={this.props.extraProperties[PRESENCE_DETECTION8.presenceDetectionColor]}
                                        inputPadding={'padding-none'}
                                        title={this.props.extraProperties[PRESENCE_DETECTION8.presenceDetectionColor].info['displayName']}
                                        measureUnit={this.props.extraProperties[PRESENCE_DETECTION8.presenceDetectionColor].info['unit']}
                                        min={this.props.extraProperties[PRESENCE_DETECTION8.presenceDetectionColor].valueMeta['min']}
                                        max={this.props.extraProperties[PRESENCE_DETECTION8.presenceDetectionColor].valueMeta['max']}
                                        step={1}
                                        handleChange={this.handleChange}/>

                                    : null}
                                {displayColors ?
                                    <div>
                                        <Checkbox
                                            name={"pdcolour"}
                                            checked={this.state.isCheckedPDColour}
                                            style={{margin: "auto 0.5rem"}}
                                            onChange={this.handleChangeCheckboxes}
                                        />
                                        {'Keep Astro Dim color'}
                                    </div>
                                    : null}
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col sm={5} md={5} lg={5} >
                        <Card className={this.getClassName([startFadeTime, holdTime, endFadeTime])} style={{width:'100%'}}>
                            <div className="card-header-feature">
                                {'PD Timing'}
                            </div>
                            <Card.Body className="card-body-feature" style={{paddingTop: '0.75rem'}}>
                                <PropertyDropdown
                                    disabled={disableStartFadeTime}
                                    property={startFadeTime}
                                    properties={startFadeTime.valueMeta.availableValues.sort((a, b) => parseInt(a) - parseInt(b))}
                                    propertyDisplayFunc={getMinutes}
                                    title={startFadeTime.info.displayName + ' [1]'}
                                    dropdownSize={3}
                                    measureUnit={'mm:ss'}
                                    handleChange={this.handleChange}/>
                                <PropertyDropdown
                                    property={holdTime}
                                    dropdownSize={3}
                                    properties={holdTime.valueMeta.availableValues.sort((a, b) => parseInt(a) - parseInt(b))}
                                    propertyDisplayFunc={getMinutes}
                                    title={holdTime.info.displayName + ' [2]'}
                                    measureUnit={'mm:ss'}
                                    handleChange={this.handleChange}/>
                                <PropertyDropdown
                                    property={endFadeTime}
                                    properties={endFadeTime.valueMeta.availableValues.sort((a, b) => parseInt(a) - parseInt(b))}
                                    propertyDisplayFunc={getMinutes}
                                    title={endFadeTime.info.displayName + ' [3]'}
                                    measureUnit={'mm:ss'}
                                    dropdownSize={3}
                                    handleChange={this.handleChange}/>
                            </Card.Body>
                        </Card>
                    </Col>
                    {/*<Col>
                        <Card className={this.getClassName()} style={{width:'100%'}}>
                            <div className="card-header-feature">
                                {<Trans i18nKey="PD_Sensor_type_label"/>}
                            </div>
                            <Card.Body className="card-body-feature" style={{paddingTop: '0.75rem'}}>
                                {this.presenceDetectSensorTypes.map((detectorType, idx) =>
                                    (
                                        <PropertyRadio
                                            key={idx}
                                            property={presenceDetectionSensorType}
                                            isChecked={detectorType.value === presenceDetectionSensorType.value}
                                            valueForTrue={detectorType.value.toString()}
                                            value={detectorType.value.toString()}
                                            title={<Trans i18nKey={detectorType.name}/>}
                                            disabled/>
                                    ))}
                            </Card.Body>
                        </Card>
                    </Col>*/}
                </Row>

                <div className="flex-row">
                    <Card className="card-feature-component" style={{width: '100%'}}>
                        <div className="card-header-feature">
                        </div>
                        <Card.Body className="card-body-feature" style={{paddingTop: '0.75rem'}}>
                            <DraggableAreaChart
                                containsErrors={getErrorIssues(this.props.issues, this.props.properties).length > 0}
                                id={"presenceDetection"}
                                properties={this.props.properties}
                                dataChart={dataChart}
                                x={{'title': 'Time'}}
                                y={{'title': 'Output Level (%)'}}
                                min={{y: 0, x: 0}}
                                max={{y: 110, x: 1250}}
                                tickValues={{x: [], y: []}}
                                xLabels={this.getXLabels(dataChart)}
                                yLabels={this.getYLabels(dataChart)}
                                sections={{0: "area-light", 1: "area-dark", 2: "area-light", 3: "area-dark"}}
                                handleChange={this.handleChartChange}/>
                        </Card.Body>
                    </Card>
                </div>

                <div className="flex-row">
                    <Card className="card-feature-component" style={{width: '100%'}}>
                        <div className="card-header-feature">
                        </div>
                        <Card.Body className="card-body-feature" style={{paddingTop: '0.75rem'}}>
                            <DraggableAreaChart
                                containsErrors={getErrorIssues(this.props.issues, this.props.properties).length > 0}
                                id={"pdSignal"}
                                type={"secondary"}
                                height={200}
                                properties={this.props.properties}
                                dataChart={this.getDataChartPD(this.props.properties)}
                                x={{'title': 'Time'}}
                                y={{'title': 'PD-Signal'}}
                                min={{y: 0, x: 0}}
                                max={{y: 100, x: 1250}}
                                tickValues={{x: [], y: []}}
                                xLabels={this.getXLabels(dataChart)}
                                handleChange={this.handleChartChange}/>
                        </Card.Body>
                    </Card>
                </div>
            </Col>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
        opmodesSelected: state.driver.opmodesSelected,
    };
};

const mapDispatchToProps = {}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PresenceDetection);
